module.exports = __webpack_public_path__ + "img-dashboard/register/icon-setting.cfc2d33d.svg";